var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{attrs:{"id":"loading-indicator"}},[_c('div',{staticClass:"fas fa-circle-notch fa-spin fa-4x spinner"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }